import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cp-bg text-slate-400" data-testid="auth-loading">
        <span className="font-mono text-sm">carregando sessão…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
